<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>

    <div
      class="d-flex pa-2 flex-row flex-wrap"
      :style="{ height: 'fit-content' }"
    >
      <card-row
        :title="'Search'"
        :textColor="'black'"
        :cardColor="'white'"
        :displayed="true"
      >
        <div style="width: 100%">
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="search.rrn_reff"
                label="Reff ID"
                item-text="text"
                item-value="value"
                v-on:enter="getData"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-btn color="primary" class="mt-4" @click.stop="showType"
                >show</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </card-row>
    </div>

    <v-data-table
      :headers="headers"
      fixed-header
      :items="allData"
      :options.sync="options"
      :server-items-length="totalData"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      item-key="trx_id"
      sort-by="trx_datetime"
      :sort-desc="true"
      :style="{ padding: '10px', height: '70vh' }"
    >
      <template v-slot:[`body.prepend`]>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 pl-4 d-block d-sm-table-cell d-print-table-cell fixed-row"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-checkbox
                    class="ma-0"
                    dense
                    hide-details="true"
                    v-model="selectAllData"
                    @click="selectAll(selectAllData)"
                  />
                </div>
              </template>
              <span>Select All</span>
            </v-tooltip>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.bill_num"
              type="text"
              label="Bill Number"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>

          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mid"
              type="text"
              label="MID"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mpan"
              type="text"
              label="MPAN"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>

          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.qr_method"
              :items="qrMethod"
              label="QR Method"
              item-text="text"
              item-value="value"
              @change="getData"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.qr_type"
              :items="qrType"
              label="QR Type"
              item-text="text"
              item-value="value"
              @change="getData"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.trx_type"
              :items="listTrxType"
              label="Transaction Type"
              item-text="text"
              item-value="value"
              @change="getData"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-autocomplete
              clearable
              v-model="search.issuer_name"
              :items="itemsIssuer"
              item-text="issuer_name"
              item-value="issuer_name"
              label="Issuer Name"
              :loading="loadingIssuer"
              :search-input.sync="searchIssuer"
              @change="getData"
              hide-selected
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.customer_pan"
              label="Customer PAN"
              type="text"
              @change="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.customer_name"
              label="Customer Name"
              type="text"
              @change="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.payment_type"
              :items="listPaymentType"
              label="Payment Type"
              item-text="text"
              item-value="value"
              @change="getData"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-autocomplete
              clearable
              v-model="search.payment_channel"
              :items="itemsAcquirer"
              item-text="payment_channel"
              item-value="payment_channel"
              label="Acquirer Name"
              :loading="loadingAcquirer"
              :search-input.sync="searchAcquirer"
              @change="getData"
              hide-selected
              hide-details="true"
              dense
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <td
                class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
                v-bind="attrs"
                v-on="on"
              >
                <v-menu
                  ref="dateMenu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="trxDateRangeText"
                      label="Transaction Date"
                      v-bind="attrs"
                      v-on="on"
                      hide-details="true"
                      dense
                      readonly
                      clearable
                    />
                  </template>
                  <v-date-picker
                    v-model="search.trx_datetime"
                    no-title
                    range
                    :min="minDate"
                    :max="maxDate"
                  />
                </v-menu>
              </td>
            </template>
            <span
              v-text="
                trxDateRangeText == '' ? 'not selected' : trxDateRangeText
              "
            />
          </v-tooltip>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.refund_calculation"
              type="text"
              label="Refund Calculation"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-chip
            v-if="selectedData.length > 0"
            close
            @click:close="clearSelected"
          >
            {{ `${selectedData.length} data(s) selected` }}
          </v-chip>

          <v-spacer />
          <template>
            <v-btn
              color="primary"
              class="mb-2"
              @click="openSelectModal(true)"
              :style="{ 'margin-right': '10px' }"
              :disabled="loading"
              >Refund
            </v-btn>
            <!-- <v-btn
              color="red"
              class="mb-2 white--text"
              @click="openSelectModal(false)"
              :style="{ 'margin-right': '10px' }"
              :disabled="loading"
              >Refund All
            </v-btn> -->
            <v-btn
              color="warning"
              class="mb-2"
              @click="getData"
              :loading="loading"
              :disabled="loading"
              :style="{ 'margin-right': '10px' }"
              ><v-icon>mdi-restart</v-icon></v-btn
            >
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer' }"
          :class="selectedRow == index ? 'indigo lighten-5' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-checkbox
              class="ma-0"
              dense
              hide-details="true"
              v-model="selectedData"
              :value="item.id"
            />
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.bill_num }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_name }}
          </td>

          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mid }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mpan }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.rrn }}
          </td>

          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.qr_method }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.qr_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.trx_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.issuer_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.customer_pan }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.customer_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.payment_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.payment_channel }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.amount }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.trx_datetime }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.refund_calculation }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-icon small class="mr-2" @click="viewItem(item)">
              mdi-eye
            </v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="selectStatus" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pt-3">
          Loading ...
          <v-progress-linear v-model="percentage" color="orange" height="15">
            <strong>{{ Math.ceil(percentage) }}%</strong>
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <refund-internal-detail
      :dialogrRf="dialog"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      v-on:clearSelectedParent="clearSelected"
      v-on:closeCancelParent="close"
      v-on:fetchDataParent="getData"
    />

    <v-dialog v-model="dialogConfirm" width="500" persistent>
      <confirm-dialog
        :title="'Are you sure want to refund ?'"
        :caution="'Caution: this action cannot be undone !'"
        v-on:closeCancelParent="close"
        v-on:confirmParent="refundData"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import {
  dataListPaymentType,
  dataListTrxType,
  dataQrMethod,
  dataQrType,
} from '../../store/params';
import { getDate, date, showAlert } from '../../lib/helpers';

export default {
  components: {
    refundInternalDetail: () =>
      import('../../components/form/RefundInternalDetail.vue'),
    confirmDialog: () => import('../../components/ConfirmDialog.vue'),
    CardRow: () => import('../../components/CardRow.vue'),
  },
  data: () => ({
    options: {},
    show: false,
    dialog: false,
    dialogConfirm: false,
    expanded: [],
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'trx_id',
        sortable: false,
        width: '10',
      },
      {
        text: '#',
        align: 'center',
        value: '#',
        sortable: false,
      },
      {
        text: 'Bill Number',
        value: 'bill_num',
        width: '150',
        align: 'center',
      },
      {
        text: 'Merchant Name',
        value: 'merchant_name',
        width: '150',
        align: 'center',
      },

      {
        text: 'MID',
        value: 'mid',
        width: '150',
        align: 'center',
      },
      {
        text: 'Merchant PAN',
        value: 'mpan',
        width: '150',
        align: 'center',
      },
      {
        text: 'Reff ID',
        value: 'rrn',
        width: '150',
        align: 'center',
      },
      {
        text: 'QR Method',
        value: 'qr_method',
        width: '100',
        align: 'center',
      },
      {
        text: 'QR Type',
        value: 'qr_type',
        width: '100',
        align: 'center',
      },
      {
        text: 'Transaction Type',
        value: 'trx_type',
        width: '100',
        align: 'center',
      },
      {
        text: 'Issuer Name',
        value: 'issuer_name',
        width: '100',
        align: 'center',
      },
      {
        text: 'Customer PAN',
        value: 'customer_pan',
        width: '150',
        align: 'center',
      },
      {
        text: 'Customer Name',
        value: 'customer_name',
        width: '150',
        align: 'center',
      },
      {
        text: 'Payment Type',
        value: 'payment_type',
        width: '100',
        align: 'center',
      },
      {
        text: 'Acquirer Name',
        value: 'payment_channel',
        width: '150',
        align: 'center',
      },
      {
        text: 'Total Amount',
        value: 'amount',
        width: '150',
        align: 'center',
      },
      {
        text: 'Transaction Date',
        value: 'trx_datetime',
        width: '150',
        align: 'center',
      },
      {
        text: 'Refund Calculation',
        value: 'refund_calculation',
        width: '150',
        align: 'center',
      },
      { text: 'Action', value: 'actions', sortable: false },
    ],
    search: {
      bill_num: '',
      mid: '',
      mpan: '',
      rrn_reff: '',
      qr_method: '',
      qr_type: '',
      trx_type: '',
      issuer_name: '',
      customer_pan: '',
      customer_name: '',
      payment_type: '',
      payment_channel: '',
      trx_datetime: [],
      refund_calculation: '',
    },
    editedItem: {
      bill_num: '',
      merchant_name: '',
      mid: '',
      mpan: '',
      rrn: '',
      rrn_reff: '',
      qr_method: '',
      qr_type: '',
      trx_type: '',
      customer_pan: '',
      payment_type: '',
      payment_channel: '',
      amount: '',
      currency: '',
      amount_mdr: '',
      net_amount: '',
      trx_datetime: '',
      refund_calculation: '',
    },
    defaultItem: {},
    selectedRow: '',
    searchAcquirer: '',
    searchIssuer: '',
    listPaymentType: dataListPaymentType,
    listTrxType: dataListTrxType,
    qrMethod: dataQrMethod,
    qrType: dataQrType,
    dateMenu: false,
    editedIndex: -1,
    selectedData: [],
    isFirstLoad: true,
    selectAllData: false,
    selectedStat: false,
  }),

  computed: {
    allData() {
      return this.$store.state.refundInternal.allData;
    },
    itemsAcquirer() {
      return this.$store.state.refundInternal.allAcquirer;
    },
    itemsIssuer() {
      return this.$store.state.refundInternal.allIssuer;
    },
    totalData() {
      return this.$store.state.refundInternal.totalData;
    },
    totalPage() {
      return this.$store.state.refundInternal.totalPage;
    },
    loading() {
      return this.$store.state.refundInternal.loading;
    },
    loadingAcquirer() {
      return this.$store.state.refundInternal.loadingAcquirer;
    },
    loadingIssuer() {
      return this.$store.state.refundInternal.loadingIssuer;
    },
    flashError: {
      get() {
        return this.$store.state.refundInternal.flashError;
      },
      set() {
        this.$store.commit('refundInternal/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.refundInternal.flashErrorMessage;
    },
    trxDateRangeText: {
      get() {
        return this.search.trx_datetime.join(' ~ ');
      },
      set(val) {
        if (val == null) {
          this.search.trx_datetime = [];
        }
      },
    },
    minDate() {
      return this.getDate(-7, date);
    },
    maxDate() {
      return date;
    },
    selectStatus() {
      return this.$store.state.refundInternal.refundStatus;
    },
    percentage() {
      return this.$store.state.refundInternal.percentage;
    },
  },

  watch: {
    options: {
      handler() {
        // hendle default list kosong
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('refundInternal/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
    'search.trx_datetime': {
      handler() {
        this.getData();
        if (this.search.trx_datetime.length == 2) {
          this.dateMenu = false;
        }
      },
    },
    selectedData: {
      handler() {
        this.checkAllSelected();
      },
    },
  },

  async mounted() {
    this.getAcquirer();
    this.getIssuer();
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    showType() {
      if (this.search.rrn_reff == null || this.search.rrn_reff == '') {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Reff ID required !', 'mdi-alert', 'red');
      } else {
        this.clearSelected();
        this.getData();
      }
    },

    checkRangeDate() {
      if (this.search.trx_datetime.length == 1) {
        this.search.trx_datetime.push(this.search.trx_datetime[0]);
      }
    },

    getData() {
      if (this.search.rrn_reff == '' || this.search.rrn_reff == null) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Reff ID required !', 'mdi-alert', 'red');
      } else {
        this.$store.commit('refundInternal/setFlashErrorMessage', '');
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('refundInternal/getData', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          })
          .finally(() => {
            this.checkAllSelected();
          });
      }
    },

    getAcquirer() {
      this.$store.dispatch('refundInternal/getAcquirer', {
        date,
      });
    },

    getIssuer() {
      this.$store.dispatch('refundInternal/getIssuer', {
        date,
      });
    },

    viewItem(item) {
      this.editedIndex = this.$store.state.refundInternal.allData.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.dialogConfirm = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('refundInternal/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.bill_num = '';
      this.search.mid = '';
      this.search.mpan = '';
      this.search.rrn_reff = '';
      this.search.qr_method = '';
      this.search.qr_type = '';
      this.search.trx_type = '';
      this.search.issuer_name = '';
      this.search.customer_pan = '';
      this.search.customer_name = '';
      this.search.payment_type = '';
      this.search.payment_channel = '';
      this.search.trx_datetime = [];
      this.search.refund_calculation = '';
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    clearSelected() {
      this.selectedData = [];
      this.selectAllData = false;
    },

    openSelectModal(selected) {
      this.selectedStat = selected;

      if (this.selectedStat && this.selectedData.length < 1) {
        showAlert(this.$store, 'Data must be selected!', 'mdi-alert', 'red');
      } else if (!this.selectedStat && this.allData.length < 1) {
        showAlert(this.$store, 'Data not found !', 'mdi-alert', 'red');
      } else {
        this.dialogConfirm = true;
      }
    },

    refundData() {
      this.dialogConfirm = false;
      const idData = this.selectedStat ? this.selectedData : null;

      this.$store
        .dispatch('refundInternal/bulkRefund', {
          date,
          id: idData,
          options: this.options,
          search: this.search,
        })
        .then((res) => {
          if (res !== false) {
            this.clearSelected();
          } else {
            showAlert(this.$store, 'Refund Done !', 'mdi-check-circle', 'green');
          }
        });
    },

    selectAll(status) {
      this.$nextTick(() => {
        const allIds = this.allData.map((val) => val.id);
        const filtered = allIds.filter(
          (val) => !this.selectedData.includes(val)
        );
        if (status) {
          this.selectedData = this.selectedData.concat(filtered);
        } else {
          this.selectedData = this.selectedData.filter(
            (val) => !allIds.includes(val)
          );
        }
      });
    },

    checkAllSelected() {
      const allIds = this.allData.map((val) => val.id);
      const allSelected = allIds.filter(
        (val) => !this.selectedData.includes(val)
      );
      if (
        allSelected.length == 0 &&
        this.selectedData.length > 0 &&
        this.allData.length > 0
      ) {
        this.selectAllData = true;
      } else {
        this.selectAllData = false;
      }
    },
    getDate,
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
